import { isTestnet, isProd } from '@bfe/by-env';
class WhiteListManager {
  /**
   * undefined 表示不过滤
   * 1、当从 localStorage 中出现异常时，whiteList 为 undefined
   * 2、当从 localStorage 中解析出错时，whiteList 为 undefined
   */
  private whiteList: { [key: string]: any } | undefined = undefined; 
  private mainnetWhiteList: { [key: string]: any } = {
      "USDT": "USDT",
      "BTC": "BTC",
      "DAI": "DAI",
      "USDE": "USDE",
      "SDT": "SDT",
      "SDC": "SDC",
      "1INCH": "1INCH",
      "1SOL": "1SOL",
      "3P": "3P",
      "5IRE": "5IRE",
      "A8": "A8",
      "AARK": "AARK",
      "AAVE": "AAVE",
      "ACA": "ACA",
      "ACH": "ACH",
      "ACM": "ACM",
      "ACS": "ACS",
      "ADA": "ADA",
      "AEG": "AEG",
      "AEVO": "AEVO",
      "AFC": "AFC",
      "AFG": "AFG",
      "AGI": "AGI",
      "AGLA": "AGLA",
      "AGLD": "AGLD",
      "AIOZ": "AIOZ",
      "AKI": "AKI",
      "ALGO": "ALGO",
      "ALT": "ALT",
      "ANKR": "ANKR",
      "APE": "APE",
      "APEX": "APEX",
      "APP": "APP",
      "APRS": "APRS",
      "APTR": "APTR",
      "APT": "APT",
      "ARB": "ARB",
      "ARKM": "ARKM",
      "ARTY": "ARTY",
      "AR": "AR",
      "ATH": "ATH",
      "ATOM": "ATOM",
      "AURORA": "AURORA",
      "AURY": "AURY",
      "AVAIL": "AVAIL",
      "AVA": "AVA",
      "AVAX": "AVAX",
      "AXL": "AXL",
      "AXS": "AXS",
      "AZY": "AZY",
      "BAR": "BAR",
      "BAT": "BAT",
      "BBL": "BBL",
      "BB": "BB",
      "BCH": "BCH",
      "BCUT": "BCUT",
      "BEL": "BEL",
      "BLAST": "BLAST",
      "BLOCK": "BLOCK",
      "BLUR": "BLUR",
      "BNB": "BNB",
      "BNT": "BNT",
      "BOBA": "BOBA",
      "BONUS": "BONUS",
      "BRAWL": "BRAWL",
      "BTG": "BTG",
      "BTT": "BTT",
      "BUBBLE": "BUBBLE",
      "C98": "C98",
      "CAKE": "CAKE",
      "CANDY": "CANDY",
      "CAPS": "CAPS",
      "CBK": "CBK",
      "CBX": "CBX",
      "CELO": "CELO",
      "CEL": "CEL",
      "CGPT": "CGPT",
      "CHRP": "CHRP",
      "CHZ": "CHZ",
      "CITY": "CITY",
      "CLOUD": "CLOUD",
      "CMP": "CMP",
      "COMP": "COMP",
      "COM": "COM",
      "COOKIE": "COOKIE",
      "CORE": "CORE",
      "COT": "COT",
      "COU": "COU",
      "CPOOL": "CPOOL",
      "CRDS": "CRDS",
      "CRV": "CRV",
      "CSPR": "CSPR",
      "CTA": "CTA",
      "CTC": "CTC",
      "CTT": "CTT",
      "CUSD": "CUSD",
      "CYBER": "CYBER",
      "DECHAT": "DECHAT",
      "DEFI": "DEFI",
      "DEFY": "DEFY",
      "DEVT": "DEVT",
      "DFI": "DFI",
      "DICE": "DICE",
      "DLC": "DLC",
      "DMAIL": "DMAIL",
      "DOME": "DOME",
      "DOP1": "DOP1",
      "DOT": "DOT",
      "DPX": "DPX",
      "DRIFT": "DRIFT",
      "DSRUN": "DSRUN",
      "DUEL": "DUEL",
      "DYDX": "DYDX",
      "DYM": "DYM",
      "DZOO": "DZOO",
      "ECOX": "ECOX",
      "EGLD": "EGLD",
      "EGO": "EGO",
      "ELDA": "ELDA",
      "ELIX": "ELIX",
      "ENA": "ENA",
      "ENJ": "ENJ",
      "ENS": "ENS",
      "EOS": "EOS",
      "ERTHA": "ERTHA",
      "ESE": "ESE",
      "ETC": "ETC",
      "ETH": "ETH",
      "ETHFI": "ETHFI",
      "ETHW": "ETHW",
      "EVER": "EVER",
      "EVERY": "EVERY",
      "EXVG": "EXVG",
      "FAME": "FAME",
      "FAR": "FAR",
      "FBU": "FBU",
      "FET": "FET",
      "FIDA": "FIDA",
      "FIL": "FIL",
      "FIRE": "FIRE",
      "FITFI": "FITFI",
      "FLIP": "FLIP",
      "FLOW": "FLOW",
      "FLR": "FLR",
      "FLT": "FLT",
      "FMB": "FMB",
      "FMC": "FMC",
      "FON": "FON",
      "FORT": "FORT",
      "FTM": "FTM",
      "FXS": "FXS",
      "G3": "G3",
      "GALA": "GALA",
      "GALAXIS": "GALAXIS",
      "GALFT": "GALFT",
      "GCAKE": "GCAKE",
      "GENE": "GENE",
      "GG": "GG",
      "GLMR": "GLMR",
      "GMRX": "GMRX",
      "GMT": "GMT",
      "GM": "GM",
      "GMX": "GMX",
      "GNS": "GNS",
      "GODS": "GODS",
      "GRAPE": "GRAPE",
      "GRT": "GRT",
      "GSTS": "GSTS",
      "GST": "GST",
      "GTAI": "GTAI",
      "G": "G",
      "HBAR": "HBAR",
      "HERO": "HERO",
      "HFT": "HFT",
      "HLG": "HLG",
      "HNT": "HNT",
      "HON": "HON",
      "HOOK": "HOOK",
      "HOT": "HOT",
      "HTX": "HTX",
      "HVH": "HVH",
      "ICP": "ICP",
      "ICX": "ICX",
      "IDU": "IDU",
      "IMX": "IMX",
      "INJ": "INJ",
      "INSP": "INSP",
      "INTER": "INTER",
      "INTX": "INTX",
      "IO": "IO",
      "IRL": "IRL",
      "IZI": "IZI",
      "JASMY": "JASMY",
      "JST": "JST",
      "JTO": "JTO",
      "JUP": "JUP",
      "JUV": "JUV",
      "KARATE": "KARATE",
      "KASTA": "KASTA",
      "KAS": "KAS",
      "KAVA": "KAVA",
      "KCAL": "KCAL",
      "KCS": "KCS",
      "KDA": "KDA",
      "KLAY": "KLAY",
      "KMNO": "KMNO",
      "KMON": "KMON",
      "KOK": "KOK",
      "KON": "KON",
      "KSM": "KSM",
      "KUB": "KUB",
      "KUNCI": "KUNCI",
      "L3": "L3",
      "LAI": "LAI",
      "LDO": "LDO",
      "LENDS": "LENDS",
      "LEVER": "LEVER",
      "LFT": "LFT",
      "LFW": "LFW",
      "LGX": "LGX",
      "LING": "LING",
      "LINK": "LINK",
      "LIS": "LIS",
      "LL": "LL",
      "LMWR": "LMWR",
      "LOOKS": "LOOKS",
      "LRC": "LRC",
      "LTC": "LTC",
      "LUNC": "LUNC",
      "MAGIC": "MAGIC",
      "MANA": "MANA",
      "MANTA": "MANTA",
      "MASA": "MASA",
      "MATIC": "MATIC",
      "MAVIA": "MAVIA",
      "MBOX": "MBOX",
      "MBS": "MBS",
      "MBX": "MBX",
      "MCG": "MCG",
      "MCRT": "MCRT",
      "MCT": "MCT",
      "MDAO": "MDAO",
      "MEE": "MEE",
      "MELOS": "MELOS",
      "MERL": "MERL",
      "METH": "METH",
      "MEW": "MEW",
      "MINA": "MINA",
      "MINU": "MINU",
      "MIX": "MIX",
      "MKR": "MKR",
      "MLK": "MLK",
      "MMC": "MMC",
      "MNT": "MNT",
      "MOCA": "MOCA",
      "MODE": "MODE",
      "MOJO": "MOJO",
      "MON": "MON",
      "MOVEZ": "MOVEZ",
      "MOVR": "MOVR",
      "MPLX": "MPLX",
      "MSTAR": "MSTAR",
      "MVL": "MVL",
      "MV": "MV",
      "MXM": "MXM",
      "MX": "MX",
      "MYRIA": "MYRIA",
      "NAKA": "NAKA",
      "NEAR": "NEAR",
      "NEON": "NEON",
      "NESS": "NESS",
      "NEXO": "NEXO",
      "NEXT": "NEXT",
      "NFT": "NFT",
      "NGL": "NGL",
      "NIBI": "NIBI",
      "NLK": "NLK",
      "NOT": "NOT",
      "NRN": "NRN",
      "NUTS": "NUTS",
      "NYAN": "NYAN",
      "OAS": "OAS",
      "OBX": "OBX",
      "OKG": "OKG",
      "OMG": "OMG",
      "ONDO": "ONDO",
      "ONE": "ONE",
      "OP": "OP",
      "ORDI": "ORDI",
      "ORT": "ORT",
      "PARAM": "PARAM",
      "PAXG": "PAXG",
      "PBUX": "PBUX",
      "PENDLE": "PENDLE",
      "PIP": "PIP",
      "PIXFI": "PIXFI",
      "PLANET": "PLANET",
      "PLT": "PLT",
      "PLY": "PLY",
      "POKT": "POKT",
      "POL": "POL",
      "PORT3": "PORT3",
      "PORTAL": "PORTAL",
      "PPT": "PPT",
      "PRCL": "PRCL",
      "PRIMAL": "PRIMAL",
      "PSG": "PSG",
      "PSP": "PSP",
      "PSTAKE": "PSTAKE",
      "PTC": "PTC",
      "PTU": "PTU",
      "PUMLX": "PUMLX",
      "PURSE": "PURSE",
      "PYTH": "PYTH",
      "PYUSD": "PYUSD",
      "QMALL": "QMALL",
      "QNT": "QNT",
      "QORPO": "QORPO",
      "QTUM": "QTUM",
      "RACA": "RACA",
      "RAIN": "RAIN",
      "RATS": "RATS",
      "RDNT": "RDNT",
      "REAL": "REAL",
      "RENDER": "RENDER",
      "REN": "REN",
      "ROND": "ROND",
      "ROOT": "ROOT",
      "ROUTE": "ROUTE",
      "RPK": "RPK",
      "RPL": "RPL",
      "RSS3": "RSS3",
      "RUBY": "RUBY",
      "RUNE": "RUNE",
      "RVN": "RVN",
      "SAFE": "SAFE",
      "SAIL": "SAIL",
      "SALD": "SALD",
      "SAND": "SAND",
      "SAROS": "SAROS",
      "SATS": "SATS",
      "SCA": "SCA",
      "SD": "SD",
      "SEILOR": "SEILOR",
      "SEI": "SEI",
      "SEOR": "SEOR",
      "SFUND": "SFUND",
      "SHARK": "SHARK",
      "SHILL": "SHILL",
      "SHRAP": "SHRAP",
      "SIDUS": "SIDUS",
      "SIS": "SIS",
      "SLP": "SLP",
      "SNX": "SNX",
      "SOL": "SOL",
      "SON": "SON",
      "SOS": "SOS",
      "SPARTA": "SPARTA",
      "SPEC": "SPEC",
      "SPELL": "SPELL",
      "SQD": "SQD",
      "SQR": "SQR",
      "SQT": "SQT",
      "SRM": "SRM",
      "SSV": "SSV",
      "STAR": "STAR",
      "STAT": "STAT",
      "STETH": "STETH",
      "STG": "STG",
      "STRK": "STRK",
      "STRM": "STRM",
      "STX": "STX",
      "SUIA": "SUIA",
      "SUIU": "SUIU",
      "SUN": "SUN",
      "SUSHI": "SUSHI",
      "SVL": "SVL",
      "SWEAT": "SWEAT",
      "TAIKO": "TAIKO",
      "TAI": "TAI",
      "TAP": "TAP",
      "TAVA": "TAVA",
      "TEL": "TEL",
      "TENET": "TENET",
      "THETA": "THETA",
      "THN": "THN",
      "TIA": "TIA",
      "TNSR": "TNSR",
      "TOKEN": "TOKEN",
      "TOMI": "TOMI",
      "TON": "TON",
      "TRC": "TRC",
      "TRVL": "TRVL",
      "TRX": "TRX",
      "TST": "TST",
      "TURBOS": "TURBOS",
      "T": "T",
      "TUSD": "TUSD",
      "TVK": "TVK",
      "TWT": "TWT",
      "ULTI": "ULTI",
      "UMA": "UMA",
      "UNI": "UNI",
      "USDC": "USDC",
      "USDD": "USDD",
      "USDY": "USDY",
      "USTC": "USTC",
      "UXLINK": "UXLINK",
      "VANRY": "VANRY",
      "VEGA": "VEGA",
      "VELAR": "VELAR",
      "VELA": "VELA",
      "VELO": "VELO",
      "VENOM": "VENOM",
      "VEXT": "VEXT",
      "VIC": "VIC",
      "VPAD": "VPAD",
      "VPR": "VPR",
      "VRA": "VRA",
      "VRTX": "VRTX",
      "VV": "VV",
      "WAVES": "WAVES",
      "WAXP": "WAXP",
      "WBTC": "WBTC",
      "WEETH": "WEETH",
      "WELL": "WELL",
      "WEMIX": "WEMIX",
      "WLD": "WLD",
      "WLKN": "WLKN",
      "WOO": "WOO",
      "W": "W",
      "WWY": "WWY",
      "XAI": "XAI",
      "XAR": "XAR",
      "XAVA": "XAVA",
      "XCAD": "XCAD",
      "XDCU": "XDCU",
      "XECU": "XECU",
      "XEMU": "XEMU",
      "XETA": "XETA",
      "XLM": "XLM",
      "XRP": "XRP",
      "XTZ": "XTZ",
      "XWG": "XWG",
      "XYM": "XYM",
      "XZK": "XZK",
      "YFI": "YFI",
      "ZAM": "ZAM",
      "ZEND": "ZEND",
      "ZENT": "ZENT",
      "ZEN": "ZEN",
      "ZETA": "ZETA",
      "ZEX": "ZEX",
      "ZIG": "ZIG",
      "ZIL": "ZIL",
      "ZKF": "ZKF",
      "ZKJ": "ZKJ",
      "ZKL": "ZKL",
      "ZKU": "ZKU",
      "ZRO": "ZRO",
      "ZRX": "ZRX",
      "ZTX": "ZTX",
      "BICO": "BICO",
      "CO": "CO",
      "FB": "FB",
      "ID": "ID",
      "ORDER": "ORDER",
      "PERP": "PERP",
      "PRIME": "PRIME",
      "SOLO": "SOLO",
      "SUI": "SUI",
      "XEC": "XEC",
      "XEM": "XEM",
      "ZK": "ZK",
      "DAPP": "DAPP",
      "PUFFER": "PUFFER",
      "CARV": "CARV",
      "DEEP": "DEEP",
      "COOK": "COOK",
      "GRASS": "GRASS",
      "SMILE": "SMILE",
      "NS": "NS",
      "SUPRA": "SUPRA",
      "XION": "XION",
      "MOVE": "MOVE",
      "VANA": "VANA",
      "FLUID": "FLUID",
      "STOP": "STOP",
      "OL": "OL",
      "MAJOR": "MAJOR",
      "ODOS": "ODOS",
      "USDT,USDC":"USDT,USDC"
  }

  constructor() {
    this.initializeWhiteList();
  }

  /**
   * 获取 localStorage 中的白名单数据
   */
  private getWhiteListFromLocalStorage(): { [key: string]: any } {
    const whiteList = localStorage.getItem('DEVELOPMENT_WHITE_LIST');
    if (whiteList) {
      try {
        return JSON.parse(whiteList);
      } catch (err) {
        console.error(
          '[WhiteListManager]',
          'localStorage白名单数据解析失败',
          err
        );
      }
    }
    return undefined
  }

  /**
   * 实例化白名单对象并初始化数据
   */
  private initializeWhiteList(): void {
    if (typeof window !== 'undefined') {
      if(isProd || isTestnet){
        this.whiteList = this.mainnetWhiteList;
      }else{
        this.whiteList = this.getWhiteListFromLocalStorage();
      }
    }
  }

  /**
   * 白名单中是否存在指定的token
   * 只有指定站点才会执行白名单检查
   * 外部调用时需要先判断当前站点是否需要过滤
   */
  public isInWhiteList(token: string): boolean {
    return Boolean(this.whiteList[token]);
  }

  /**
   * 判断是否是需要过滤
   * 目前只有HAZ站点需要过滤
   */
  public isNeedFilter(): boolean {
    if (typeof window === 'undefined' || typeof this.whiteList === 'undefined') {
      return false;
    }
    
    return window['RegulatedSiteHosts'] === "KAZ"
  }

  /**
   * 判断是否是主站
   * 目前只有BYBIT站点是主站
   */
  public isMainSite(): boolean | undefined {
    if (typeof window === 'undefined') return undefined
    return window['RegulatedSiteHosts'] === "BYBIT"
  }
}

export const whiteListManager = new WhiteListManager();
